// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Tooltip_overlay__KgqG8","isWhite":"Tooltip_isWhite__1UfWW","isDark":"Tooltip_isDark__2le4i"};